export const moljaninovoSlug = 'tekhnoklaster-molzhaninovo-mega';
/**
 * Слаги проектов которые необходимо исключить из списка при фиксации
 * временная реализация
 */
export const excludeProjects = [''];
